// Section names and URL slugs, for the section play-through pieces (Oct 20).
// The older pages each carry their own copy of these maps; new code reads
// them from here.

// ── The person's pronouns in section names (Oct 25) ───────────────────────────
// "Her Day" and "How She Communicates" were written into every page, so a
// profile about a man or a non-binary person read "Her Day". The names are
// now built from the profile's pronouns; unknown pronouns read "Their".

/** {Subj, subj, Poss, poss, plural} for a profile's pronouns string. */
export function pronounForms(pronouns) {
  const p = (pronouns || "").trim().toLowerCase();
  if (p.startsWith("she")) return { Subj: "She", subj: "she", Poss: "Her", poss: "her", plural: false };
  if (p.startsWith("he"))  return { Subj: "He", subj: "he", Poss: "His", poss: "his", plural: false };
  return { Subj: "They", subj: "they", Poss: "Their", poss: "their", plural: true };
}

const TITLE = {
  meet:        () => "Meet",
  communicate: f => `How ${f.Subj} ${f.plural ? "Communicate" : "Communicates"}`,
  sensory:     () => "Sensory",
  passions:    () => "Passions",
  day:         f => `${f.Poss} Day`,
  working_on:  () => "Working On",
  hard_times:  () => "Hard Times",
  health:      () => "Health",
  people:      () => "Important People",
  community:   () => "In the Community",
};

// Sentence case, as the Meet page lists them.
const SENTENCE = {
  meet:        () => "Meet",
  communicate: f => `How ${f.subj} ${f.plural ? "communicate" : "communicates"}`,
  sensory:     () => "Sensory",
  passions:    f => `What ${f.subj} ${f.plural ? "love" : "loves"}`,
  day:         f => `${f.Poss} day`,
  working_on:  () => "Working on",
  hard_times:  () => "Hard times",
  health:      () => "Health",
  people:      () => "Important people",
  community:   () => "In the community",
};

/** A section's name for this person: sectionLabel("day", "he/him") → "His Day". */
export function sectionLabel(type, pronouns, { sentence = false } = {}) {
  const make = (sentence ? SENTENCE : TITLE)[type];
  return make ? make(pronounForms(pronouns)) : type;
}

/** Names when the person's pronouns aren't to hand — neutral ("Their Day"). */
export const SECTION_LABELS = Object.fromEntries(
  Object.keys(TITLE).map(t => [t, sectionLabel(t, "")])
);

export const TYPE_TO_SLUG = {
  meet: "meet", communicate: "communicate", sensory: "sensory",
  passions: "passions", day: "day", working_on: "working-on",
  hard_times: "hard-times", health: "health", people: "people",
  community: "community",
};

export const SLUG_TO_TYPE = Object.fromEntries(
  Object.entries(TYPE_TO_SLUG).map(([type, slug]) => [slug, type])
);

/** The API base for a play-through: the intro's, or one section's. */
export function playthroughBase(clientId, sectionType = null) {
  return sectionType
    ? `/api/clients/${clientId}/sections/${sectionType}/playthrough`
    : `/api/clients/${clientId}/playthrough`;
}
